import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { TP } from '../../constants/consts';
import Button from '../Button';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: theme.spacing(1),
    textAlign: 'center',
    fontSize: fontSize.medium,
    color: colors.cancelButton,
    backgroundColor: 'white',
  },
  title: {
    fontWeight: 'bold',
    margin: '17px 0 10px',
  },
  button: {
    fontSize: fontSize.medium,
    marginBottom: 17,
    maxWidth: 200,
    minWidth: 'auto',
    width: '90%',
  },
}));

const NoOptionsBox = ({ buttonText, openFormFunc, t }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.title}>{t(`${TP}.NO_RESULTS`)}</div>
      <Button className={classes.button} onClick={openFormFunc}>
        {t(buttonText)}
      </Button>
    </div>
  );
};

NoOptionsBox.propTypes = {
  buttonText: PropTypes.string.isRequired,
  openFormFunc: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default NoOptionsBox;
